import * as React from 'react';

import ELearningContainer from '../containers/ELearning';

/**
 * eラーニング閲覧画面
 * @param props
 */
const ELearningPreview: React.FC<any> = props => {
	window.document.title = 'Preview';
	return (
		<ELearningContainer
			careerID={props.match.params.career_id}
			classID={props.match.params.class_id}
			outOfPeriodFlg={false}
			preview={true}
			windowId={props.match.params.window_id}
			{...props}
		/>
	);
};

export default ELearningPreview;



// WEBPACK FOOTER //
// ./src/pages/ELearningPreview.tsx